import { Component, OnInit } from '@angular/core';
import { ModalDialogNotificationService, NotificationType, ButtonClick } from '@se/se.ui.html5';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { EstensaUser } from '../../../models/estensa-models.model';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Store } from '@ngrx/store';
import { RootState } from '../../../root-store/root.state';
import { seUserLogout } from '../../../root-store/root.actions';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'se-header-user-info',
    templateUrl: './se-header-user-info.component.html',
    styleUrls: ['./se-header-user-info.component.scss'],
})
export class SeHeaderUserInfoComponent implements OnInit {
    estensaUser: EstensaUser;
    userDomainName;
    userInitials: BehaviorSubject<string>;
    completeName;

    constructor(
        private authenticationService: AuthenticationService,
        private modalDialogNotificationService: ModalDialogNotificationService,
        private store: Store<RootState>,
        private translate: TranslateService
    ) {
        this.userInitials = new BehaviorSubject<string>('');
        this.estensaUser = {
            id: '',
            domain: '',
            userName: '',
            descName: '',
            description: '',
            name: '',
            surname: '',
        };
    }

    ngOnInit() {
        this.authenticationService.getUserInfo().then(userInfo => {
            this.estensaUser = userInfo;

            this.userInitials.next(
                (this.estensaUser.name ? this.estensaUser.name.toUpperCase()[0] : '') +
                    (this.estensaUser.surname ? this.estensaUser.surname.toUpperCase()[0] : '')
            );

            this.userDomainName =
                (this.estensaUser.domain ? this.estensaUser.domain + '/' : '') + this.estensaUser.userName;
            this.completeName = (this.estensaUser.name ? this.estensaUser.name + ' ' : '') + this.estensaUser.surname;
        });
    }

    onLogoutClick = () => {
        this.modalDialogNotificationService
            .notify({
                message: this.translate.instant('ExitFromEstensa'),
                title: 'Logout',
                type: NotificationType.warning,
                buttonYes: true,
                buttonNo: true,
                buttonOk: false,
                buttonCancel: false,
            })
            .pipe(filter((button) => button === ButtonClick.yes))
            .subscribe((_) => {
                this.store.dispatch(seUserLogout({}));
            });
    };
}
